import _ from "lodash"
export const getMovementList = movement => (movement && movement.list ? movement.list : []);
export const getNewMovement = movement => _.get(movement, ["newObject"], {});
export const getExistingMovement = movement => _.get(movement, ["existingObject"], {});
export const getMovementTemplates = movement => _.get(movement, ["templates"], []);
export const getMovementImportedClientInput = movement => _.get(movement, ["clientInput"], {});
export const getMovementStockOptions = movement => _.get(movement, ["stockOptions"], []);
export const getMovementLoading = movement => _.get(movement, ["loading"], {});

export const getMovementisSuccessUpdated = movement => _.get(movement, ["isSuccessUpdated"], false);
export const getMovementDetails = (movement, rowIndex) =>
    movement && movement.list && movement.list[rowIndex] ? movement.list[rowIndex] : null;

// movement details
export const getMovementCapPrice = movement => (movement && movement.cap_price ? movement.cap_price : null);
export const getMovementQty = movement => (movement && movement.qty ? movement.qty : 0);
export const getMovementPrice = movement => (movement && movement.price ? movement.price : 0);
export const getMovementMof = movement => (movement && movement.mof ? movement.mof * 100 : 0);
export const getMovementStockName = movement => (movement && movement.stock_name ? movement.stock_name : "");
export const getMovementAmount = movement => (movement && movement.amount ? movement.amount : 0);
